// imports section Start
import React, { useContext } from "react";
import { styled, useTheme } from "@mui/material/styles";
import { useStyles } from "../../../../assets/styles/Theme";
import { Box, Grid, Typography, Paper, Button, TextField } from "@mui/material";
import { CashierContext } from "../../../../features/mobile/cashier/CashierMobile";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
// imports section End

export default function CashierDeliveryMobile() {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  const [value, setValue] = React.useState("one");
  const {
    deliveryDate,
    setDeliveryDate,
    deliveryTime,
    setDeliveryTime,
    contactPerson,
    setContactPerson,
    contactNumber,
    setContactNumber,
    deliveryAddress,
    setDeliveryAddress,
  } = useContext(CashierContext);
  // Hooks end

  // Handlers start

  // Error handling for validation (optional)
  const errors = {
    EXPIRYDATE: "Please select a valid date", // Example error message
    EXPIRYTIME: "Please select a valid time", // Example error message
  };
  // Handlers end

  return (
    <Box sx={{ ...styles.m_cs_cash, height: "70vh" }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography
            sx={{
              ...theme.typography.m_sub_title,
              color: theme.palette.text.primary,
            }}
          >
            Delivery
          </Typography>
        </Grid>

        {/* Delivery Date Picker */}
        <Grid item xs={6}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Delivery Date"
              value={deliveryDate}
              onChange={(newValue) => setDeliveryDate(newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  fullWidth
                  size="small"
                  error={Boolean(errors.EXPIRYDATE)} // Show error if present
                  helperText={errors.EXPIRYDATE} // Show helper text if present
                />
              )}
            />
          </LocalizationProvider>
        </Grid>

        {/* Delivery Time Picker */}
        <Grid item xs={6}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker
              label="Select Delivery Time"
              fullWidth
              value={deliveryTime}
              onChange={(newValue) => setDeliveryTime(newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  fullWidth
                  size="small"
                  error={Boolean(errors.EXPIRYTIME)} // Show error if present
                  helperText={errors.EXPIRYTIME} // Show helper text if present
                />
              )}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
    </Box>
  );
}
